// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__xoUFY","question":"Question_question__1j3hU","description":"Question_description__3Qmm4"};